const interfaceTranslations = {
  selectedCountryAriaLabel: "Tanlangan davlat",
  noCountrySelected: "Davlat tanlanmagan",
  countryListAriaLabel: "Davlatlar roʻyxati",
  searchPlaceholder: "Davlatni qidiring",
  zeroSearchResults: "Natija topilmadi",
  oneSearchResult: "1-ta natija topildi",
  multipleSearchResults: "${count}-ta natija topildi",
  // qo‘shimcha davlatlar (country-list kutubxonasi tomonidan qo‘llab-quvvatlanmaydi)
  ac: "Ascension oroli",
  xk: "Kosovo"
};
export default interfaceTranslations;
